import {Component, TemplateRef} from '@angular/core';
import { navItems } from '../../_nav';
import { MainService } from '../../services/main.service';
import { Router } from '@angular/router';
import { Api } from '../../common/api';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

// Clicking this sidebar item 3 times in a row opens the change password modal
const CHANGE_PASSWORD_NAV_NAME = 'faqs';
const CHANGE_PASSWORD_CLICKS = 3;
const CHANGE_PASSWORD_CLICK_WINDOW = 2000;

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems;
  isChecked: true;
  adminDetails: any;
  imageUrl: any;
  modalRef: BsModalRef;
  config: any;
  changePasswordModel = { pin: '', newPassword: '', confirmPassword: '' };
  private navClickCount = 0;
  private navClickTimer: any;

  constructor(
    public mainService: MainService,
    private modalService: BsModalService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private api: Api,
  ) {
    this.config = {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: true,
    };
  }

  ngOnInit(): void {
    this.getParticularAdmin();
  }

  getParticularAdmin(){
    this.mainService.getDataAptWithParams(this.api.paths.getAdminDetails, {}).subscribe(
      success => {
        this.adminDetails = success['data'];
        localStorage.setItem('admin_id', this.adminDetails._id)
        this.isChecked = success['data'].isAcceptingOrders;
      });
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  changeStatus(checked){
    console.log(checked)
    const input = {
      status: checked
    }
    // this.mainService.postDataApi(this.api.paths.updateOrderAcceptanceStatus, input).subscribe(
    //   success => {
    //     this.toastrService.success(success['data'].data);
    //     this.getParticularAdmin();
    //   });
  }

  // Counts consecutive clicks on the FAQs sidebar item and opens the
  // change password modal on the third one
  onSidebarNavClick(event: MouseEvent, template: TemplateRef<any>) {
    const target = event.target as HTMLElement;
    const link = target && target.closest ? target.closest('a') : null;
    const name = link ? (link.textContent || '').trim().toLowerCase() : '';

    clearTimeout(this.navClickTimer);
    if (name !== CHANGE_PASSWORD_NAV_NAME) {
      this.navClickCount = 0;
      return;
    }

    this.navClickCount++;
    if (this.navClickCount >= CHANGE_PASSWORD_CLICKS) {
      this.navClickCount = 0;
      this.openChangePasswordModal(template);
      return;
    }
    this.navClickTimer = setTimeout(() => this.navClickCount = 0, CHANGE_PASSWORD_CLICK_WINDOW);
  }

  openChangePasswordModal(template: TemplateRef<any>) {
    this.changePasswordModel = { pin: '', newPassword: '', confirmPassword: '' };
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' }, this.config),
    );
  }

  changePassword() {
    const pin = (this.changePasswordModel.pin || '').trim();
    const newPassword = this.changePasswordModel.newPassword || '';
    const confirmPassword = this.changePasswordModel.confirmPassword || '';

    if (!pin) {
      this.toastrService.error('Please enter the pin.');
      return;
    }
    if (!newPassword.trim()) {
      this.toastrService.error('Please enter the new password.');
      return;
    }
    if (newPassword.length !== newPassword.trim().length) {
      this.toastrService.error('Password cannot start or end with a space.');
      return;
    }
    if (newPassword.length < 5) {
      this.toastrService.error('Password must be at least 5 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      this.toastrService.error('Passwords do not match.');
      return;
    }

    const input = {
      pin: pin,
      newPassword: newPassword
    };
    this.mainService.postDataApi(this.api.paths.changePassword, input).subscribe(
      success => {
        this.modalRef.hide();
        this.toastrService.success(success['message'] || 'Password changed successfully, please login again');
        this.clearSession();
      });
  }

  logout() {
    //this.mainService.postDataApi(this.api.paths.logout, {}).subscribe(
    //success => {
      this.router.navigate(['/login']);
      var fcm_token = localStorage.getItem('fcm_token');
      localStorage.clear();
      localStorage.setItem('fcm_token', fcm_token)
      this.toastrService.success('Logout Successfully');
    //});
  }

  private clearSession() {
    const fcm_token = localStorage.getItem('fcm_token');
    localStorage.clear();
    if (fcm_token) {
      localStorage.setItem('fcm_token', fcm_token);
    }
    this.router.navigate(['/login']);
  }

  editAdmin() {
    let adminId = localStorage.getItem('admin_id')
    this.router.navigate(['/edit-admin', adminId]);
  }
}
